var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "act-liveness-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "liveness-content",
          style: `margin-top:-${_vm.barHeight + 46}px`,
        },
        [
          _vm.$i18n.locale === "es"
            ? _c("img", {
                staticClass: "banner-img",
                attrs: { src: require("./images/banner-es.png") },
              })
            : _c("img", {
                staticClass: "banner-img",
                attrs: { src: require("./images/banner-en.png") },
              }),
          _c("div", { staticClass: "reward-table" }, [
            _c("div", { staticClass: "reward-table-item reward-table-head" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k120")))]),
              _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k121")))]),
              _c("div", [_vm._v(_vm._s(_vm.$t("lang.mybean.bonus")))]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg2" }, [
              _c("div", [_vm._v("L0-L2")]),
              _c("div", [_vm._v("L3")]),
              _c("div", [
                _vm._v(" 800 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg3" }, [
              _c("div", [_vm._v("L0-L3")]),
              _c("div", [_vm._v("L4")]),
              _c("div", [
                _vm._v(" 2,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg2" }, [
              _c("div", [_vm._v("L0-L4")]),
              _c("div", [_vm._v("L5")]),
              _c("div", [
                _vm._v(" 5,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg3" }, [
              _c("div", [_vm._v("L0-L5")]),
              _c("div", [_vm._v("L6")]),
              _c("div", [
                _vm._v(" 10,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg2" }, [
              _c("div", [_vm._v("L0-L6")]),
              _c("div", [_vm._v("L7")]),
              _c("div", [
                _vm._v(" 20,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg3" }, [
              _c("div", [_vm._v("L0-L7")]),
              _c("div", [_vm._v("L8")]),
              _c("div", [
                _vm._v(" 40,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg2" }, [
              _c("div", [_vm._v("L0-L8")]),
              _c("div", [_vm._v("L9")]),
              _c("div", [
                _vm._v(" 70,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
            _c("div", { staticClass: "reward-table-item tr-bg3" }, [
              _c("div", [_vm._v("L0-L9")]),
              _c("div", [_vm._v("L10")]),
              _c("div", [
                _vm._v(" 100,000 "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "tips-bg" }, [
            _c("div", { staticClass: "tips-tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k122"))),
            ]),
            _c("div", { staticClass: "tips-con" }, [
              _c("span", { staticClass: "tips-order" }, [_vm._v("1.")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k123")) + " "),
            ]),
            _c("div", { staticClass: "tips-con" }, [
              _c("span", { staticClass: "tips-order" }, [_vm._v("2.")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k124")) + " "),
            ]),
            _c("div", { staticClass: "tips-con" }, [
              _c("span", { staticClass: "tips-order" }, [_vm._v("3.")]),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k125")) + " "),
              _c("i", [_vm._v("01/09/2025 00:05:00")]),
            ]),
          ]),
          _c("div", { staticClass: "rules-btn", on: { click: _vm.toRules } }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k126"))),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }